import { render, staticRenderFns } from "./goals-table-item.vue?vue&type=template&id=f9444654&scoped=true&"
import script from "./goals-table-item.vue?vue&type=script&lang=js&"
export * from "./goals-table-item.vue?vue&type=script&lang=js&"
import style0 from "./goals-table-item.vue?vue&type=style&index=0&id=f9444654&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f9444654",
  null
  
)

export default component.exports